import React, { useState, useMemo } from 'react';
import './SelectLocationModal.scss';

function SelectLocationModal({ pitches, onClose, onSelectLocation }) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredPitches = useMemo(() => {
    if (!searchQuery.trim()) {
      return pitches;
    }
    
    const query = searchQuery.toLowerCase();
    return pitches.filter(pitch => {
      const name = (pitch.name || '').toLowerCase();
      const address1 = (pitch.address_1 || '').toLowerCase();
      const address2 = (pitch.address_2 || '').toLowerCase();
      const town = (pitch.town || '').toLowerCase();
      const county = (pitch.county || '').toLowerCase();
      const postcode = (pitch.postcode || '').toLowerCase();
      const facilities = (pitch.facilities || '').toLowerCase();
      
      return name.includes(query) || 
             address1.includes(query) || 
             address2.includes(query) ||
             town.includes(query) ||
             county.includes(query) ||
             postcode.includes(query) ||
             facilities.includes(query);
    });
  }, [pitches, searchQuery]);

  const handleSelectLocation = (pitch) => {
    if (onSelectLocation) {
      onSelectLocation(pitch);
    }
    onClose();
  };

  const formatAddress = (pitch) => {
    const parts = [];
    if (pitch.address_1) parts.push(pitch.address_1);
    if (pitch.town) parts.push(pitch.town);
    if (pitch.county) parts.push(pitch.county);
    return parts.join(', ');
  };

  return (
    <div className="select-location-modal modal-overlay" onClick={onClose}>
      <div className="modal-content modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        <h2>Select Location</h2>
        
        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search by name, address, town, county, or facilities..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            autoFocus
          />
        </div>

        <div className="pitches-list">
          {filteredPitches.length === 0 ? (
            <div className="no-results">
              {searchQuery ? 'No locations found matching your search.' : 'No locations available.'}
            </div>
          ) : (
            filteredPitches.map((pitch) => (
              <div
                key={pitch.pitch_id}
                className="pitch-item"
                onClick={() => handleSelectLocation(pitch)}
              >
                <div className="pitch-main-info">
                  <div className="pitch-name">
                    {pitch.name}
                  </div>
                  {formatAddress(pitch) && (
                    <div className="pitch-address">
                      {formatAddress(pitch)}
                    </div>
                  )}
                  {pitch.postcode && (
                    <div className="pitch-postcode">
                      {pitch.postcode}
                    </div>
                  )}
                </div>
                {pitch.facilities && (
                  <div className="pitch-facilities">
                    {pitch.facilities}
                  </div>
                )}
              </div>
            ))
          )}
        </div>

        <div className="modal-actions">
          <button 
            type="button" 
            className="cancel-button" 
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default SelectLocationModal;










